<template lang="pug">
div
  v-list
    v-list-item(
      v-for="link in links"
      :key="link.target"
      link
      dense
      color="secondary ligthen-1"
      @click="$go(link.target)"
    )
      v-list-item-avatar
        v-icon {{ `mdi-${link.icon}` || 'mdi-menu-right' }}

      v-list-item-content.text-no-wrap
        v-list-item-title {{ link.title }}
</template>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/misc.scss';
</style>

<script>
export default {
  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,
  },

  computed: {
    props: vm => vm.entity?.props || {},
    title: vm => vm.entity?.title || vm.blueprint?.self,

    links () {
      return (this.entity?.links)
        ? this.entity.links.filter(link => link.rel === 'MainMenu')
        : []
    },
  },
}
</script>
